//summary-card.js
import React, { useEffect, useState } from 'react'
import GridWrapper from '../../grid-wrapper'
import SummaryDonutChart from './summary-donut-chart'
const SummaryCard = ({ leadsRdx }) => {
	const [topValue, setTopValue] = useState(' ')
	const [bottomValue, setBottomValue] = useState(' ')

	useEffect(() => {
		setBottomValue(
			leadsRdx.leads_last30Days?.length > 0
				? leadsRdx.leads_last30Days.length
				: ' ',
		)
		setTopValue(
			leadsRdx.leads_last7Days?.length > 0
				? leadsRdx.leads_last7Days.length
				: ' ',
		)
	}, [leadsRdx.leads_last30Days, leadsRdx.leads_last7Days])

	return (
		<GridWrapper
			firstLine={'Leads Generated'}
			secondLine={'All Lead Types'}
			colSpan={' md:col-span-1 '}
		>
			{/* <!-- Large Text --> */}
			<div className='flex justify-between'>
				<p className='relative z-10 mt-6 text-xl'>{`Previous 7 days: `}</p>
				<p className='relative z-10 mt-6 text-xl'>{topValue}</p>
			</div>
			{/* <!-- Small Text --> */}
			<div className='flex justify-between'>
				<p className='mt-6 opacity-50 line-clamp-6'>Previous 30 days:</p>
				<p className='mt-6 opacity-50 line-clamp-6 tex'>{bottomValue}</p>
			</div>

			<SummaryDonutChart
				data={[
					{ name: 'Last 7 days', value: topValue },
					{ name: 'Last 30 days', value: bottomValue },
				]}
			/>
		</GridWrapper>
	)
}

export default SummaryCard
